export function initialize() {
    document.addEventListener('click', function(e) {
        let subBtn = <HTMLElement|null>(<HTMLElement>e.target).closest('[data-btn="minus"]');

        if(subBtn !== null) {
            console.log('invoke subBtn');
            e.preventDefault();
            sub(subBtn);
        } else {
            let addBtn = <HTMLElement|null>(<HTMLElement>e.target).closest('[data-btn="plus"]');

            if(addBtn !== null) {
                console.log('invoke addBtn');
                e.preventDefault();
                add(addBtn);
            }
        }

    });
}

function add(btn: HTMLElement)
{
    let input = getInput(btn);

    if(input) {
        try{
            console.log('Browser stepUp');
            input.stepUp();
        }catch(ex){
            console.log('Missing stepUp');
            let step = Number(input.step || 1);
            input.value = (Number(input.value) + step) + '';
        }

        input.dispatchEvent(new Event('change', {'bubbles': true}));
    }

}

function sub(btn: HTMLElement)
{
    let input = getInput(btn);

    if(input) {
        try{
            console.log('Browser stepDown');
            input.stepDown();
        }catch(ex){
            console.log('Missing stepDown');
            let step = Number(input.step || 1);
            let newValue = Number(input.value) - step;
            let minimalValue = Number(input.min);

            if(newValue < minimalValue) {
                newValue = minimalValue;
            }

            input.value = newValue + '';
        }

        input.dispatchEvent(new Event('change', {'bubbles': true}));
    }
}

function getInput(btn: HTMLElement): HTMLInputElement
{
    return <HTMLInputElement>(<HTMLElement>btn
        .closest('[data-btn="area"]'))
        .querySelector('[type="number"]');
}
